import styled from 'styled-components';

export const StyledAlertsContainer = styled.div`
    overflow: auto;
    & span.guideline-alert-lender-code {
        font-weight: 500;
        width: 2.5rem;
        display: inline-block;
    }
`;
